import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

@Pipe({
  name: 'traduzione' 
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(private translate: TranslateService, private injector: Injector) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }
  transform(key: string): string {
    return this.asyncPipe.transform(this.translate.getTraduzione$(key));
  }
  ngOnDestroy() {
    this.asyncPipe.ngOnDestroy();
  }
}
